module.exports = __webpack_public_path__ + "static/media/data-analysis.01829882.svg";